import { useState } from "react";
import { SCHEDULE_ERROR_TEXTS } from "../../../Dialogs/constants";
import { isScheduleField } from "../helpers";
import { FORM_KEYS, INIT_FORM, INIT_FORM_ERROR } from "../constants";
import { FORM_ERRORS_KEYS } from "views/Recursos/ResourcesUniversitySpaces/ScheduleFreeActivity/AdminReservationForm/utils/constants";

const useScheduleForm = () => {
	//#region States
	const [form, setForm] = useState({ ...INIT_FORM });
	const [errors, setErrors] = useState({ ...INIT_FORM_ERROR });
	//#endregion
	//#region Functions
	function clearForm() {
        setForm({ ...INIT_FORM });
    }
	function setField(field, value) {
        setForm(prev => ({
            ...prev,
            [field]: value
        }));
        if (isScheduleField(field)) 
            setScheduleError(null)
    }
    function setError(field, value) {
        setErrors(prev => ({
            ...prev,
            [field]: value
        }));
    }
	function setDays(value) {
        let newDaysIds = [];
        if (form.daysIds.some(id => id === value)) 
            newDaysIds = form.daysIds.filter(id => id !== value);
        else newDaysIds = [...form.daysIds, value];
        setField(FORM_KEYS.DAYS_IDS, newDaysIds);
    }
    function setTimeStart(value) {
        setField(FORM_KEYS.TIME_START, value);
    }
    function setTimeEnd(value) {
        setField(FORM_KEYS.TIME_END, value);
    }
    function isDaySelected(dayId) {
        return form.daysIds.some(value => value === dayId);
    }
	function isCompletedForm() {
        const { daysIds, timeStart, timeEnd } = form;
        return (
            daysIds.length > 0 &&
            timeStart >= 0 &&
            timeEnd >= 0
        );
    }
    function checkScheduleError() {
        const { timeStart, timeEnd } = form;
        if (timeStart >= timeEnd) 
            return SCHEDULE_ERROR_TEXTS.START_DATE_IS_GREATER_THAN_END_DATE;
		return null;
    }
    function setScheduleError(error) {
        setError(FORM_ERRORS_KEYS.SCHEDULE, error);
    }
    function validateForm() {
        const scheduleError = checkScheduleError();
        setScheduleError(scheduleError);
        return Boolean(
            !scheduleError
        );
    }
	//#endregion
	return {
		value: form,
        errors,
		setDays, setTimeStart, setTimeEnd,
        isDaySelected,
        checkScheduleError,
		clear: clearForm,
        validate: validateForm,
		isCompleted: isCompletedForm
	};
}	
	
export default useScheduleForm;